export default {
  methods: {
    getFilteredOptions(node, options) {
      // Check if filtering is enabled on this node
      if (!node.enable_option_filtering) {
        return options;
      }

      // Get the custom field name to filter by
      const customFieldName = node.custom_field_filter;
      if (!customFieldName) {
        return options;
      }

      // Get the participant's custom field value from Vuex store
      const participantValue = this.$store.state.customFields[customFieldName];

      // Get filter mode (inclusive or exclusive)
      const filterMode = node.filter_mode || 'inclusive';

      // Filter the options
      return options.filter((option) => {
        // If filter_values is null/empty, always show the option
        if (!option.filter_values || option.filter_values.length === 0) {
          return true;
        }

        // If participant doesn't have the custom field, hide filtered options (conservative)
        if (participantValue === undefined || participantValue === null) {
          return false;
        }

        // Check if participant's value is in the filter_values array
        // Convert all values to strings for comparison (case-insensitive)
        // Split on '|' to handle multi-select custom field values
        const filterValuesStr = option.filter_values.map((v) => String(v).trim().toLowerCase());
        const participantValues = String(participantValue).split('|').map((v) => v.trim().toLowerCase());
        const valueMatches = participantValues.some((v) => filterValuesStr.includes(v));

        // Apply filter mode logic
        if (filterMode === 'inclusive') {
          // Inclusive: show option when value matches
          return valueMatches;
        }
        // Exclusive: hide option when value matches
        return !valueMatches;
      });
    },
  },
};
